import { Head, usePage } from '@inertiajs/react'
import '../Dashboard/Dashboard.css'

export default function LandingIndex() {
  const { auth } = usePage().props as any

  if (auth?.authenticated) {
    return (
      <>
        <Head title="Dashboard" />
        <div className="p-12 text-center" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', minHeight: '100vh', width: '100vw' }}>
          <div className="glass-panel" style={{ padding: '48px', maxWidth: '500px', width: '100%' }}>
            <h1 style={{ fontSize: '2rem', fontWeight: 700, marginBottom: '16px' }}>Welcome back!</h1>
            <p style={{ color: 'var(--text-2)', marginBottom: '32px' }}>Continuining as {auth.user.email}</p>
            <div style={{ display: 'flex', gap: '16px', justifyContent: 'center' }}>
              <a href="/dashboard" className="btn btn-primary">
                Return to Dashboard
              </a>
              <a href="/users/sign_out" data-method="delete" className="btn btn-secondary">
                Sign Out
              </a>
            </div>
          </div>
        </div>
      </>
    )
  }

  return (
    <>
      <Head title="FillMyCalendar - Prospecting Infrastructure" />
      <div style={{ position: 'relative', width: '100vw', minHeight: '100vh', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>

        <div style={{
          position: 'absolute', top: '10%', left: '20%', width: '400px', height: '400px',
          background: 'radial-gradient(circle, rgba(99, 102, 241, 0.15) 0%, transparent 70%)',
          borderRadius: '50%', zIndex: -1, pointerEvents: 'none'
        }} />

        <div style={{ textAlign: 'center', maxWidth: '800px', padding: '0 24px', animation: 'slideUp 0.6s cubic-bezier(0.16, 1, 0.3, 1) forwards' }}>
          <div style={{
            display: 'inline-flex', alignItems: 'center', gap: '12px', padding: '8px 16px',
            background: 'rgba(255,255,255,0.05)', border: '1px solid var(--glass-border)',
            borderRadius: 'var(--radius-full)', marginBottom: '32px', color: 'var(--text-2)', fontSize: '0.85rem', fontWeight: 600, letterSpacing: '0.05em', textTransform: 'uppercase'
          }}>
            <span className="status-dot"></span> Next-Gen Prospecting
          </div>

          <h1 style={{
            fontSize: '4.5rem', fontWeight: 800, letterSpacing: '-0.04em', lineHeight: 1.1, marginBottom: '24px',
            background: 'linear-gradient(to right, #fff, #94a3b8)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent'
          }}>
            More Conversions.<br />Less Friction.
          </h1>

          <p style={{ fontSize: '1.25rem', color: 'var(--text-2)', lineHeight: 1.6, marginBottom: '48px', maxWidth: '600px', margin: '0 auto 48px auto' }}>
            FillMyCalendar connects high-intent homeowners to the service providers that matter. Supercharge your outbound with dynamic skip-tracing and automated SMS followups.
          </p>

          <div style={{ display: 'flex', gap: '16px', justifyContent: 'center' }}>
            <a
              href="/users/sign_up"
              className="btn btn-primary"
              style={{ padding: '16px 32px', fontSize: '1.1rem', borderRadius: 'var(--radius-full)', textDecoration: 'none' }}
            >
              Start Closing Deals <i className="fa-solid fa-arrow-right"></i>
            </a>
            <a
              href="/users/sign_in"
              className="btn btn-secondary"
              style={{ padding: '16px 32px', fontSize: '1.1rem', borderRadius: 'var(--radius-full)', background: 'rgba(0,0,0,0.2)', textDecoration: 'none' }}
            >
              Sign In to Dashboard
            </a>
          </div>

          <div style={{ marginTop: '80px', display: 'flex', justifyContent: 'center', gap: '48px', opacity: 0.5 }}>
            <div style={{ fontSize: '1.5rem', fontWeight: 700, letterSpacing: '-0.02em', display: 'flex', alignItems: 'center', gap: '8px' }}><i className="fa-solid fa-bolt text-indigo-500"></i> BatchData</div>
            <div style={{ fontSize: '1.5rem', fontWeight: 700, letterSpacing: '-0.02em', display: 'flex', alignItems: 'center', gap: '8px' }}><i className="fa-solid fa-message text-pink-500"></i> SignalHouse</div>
          </div>
        </div>
      </div>
    </>
  )
}
